import React, { Component } from 'react';


export class Footer extends Component {
  render(){
    return (
      <footer className='clearfix'>
        <div className='social-box'>
          <div className='social-btn fb'>
            <a href="https://www.facebook.com/MidoriFrauen" id='fb-btn' target='_blank' rel="noopener noreferrer">
              <i className="fab fa-facebook-f"/>
            </a>
          </div>
          <div className='social-btn tw'>
            <a href="https://twitter.com/MidoriFrauen" id='tw-btn' target='_blank' rel="noopener noreferrer">
              <i className="fab fa-twitter"/>
            </a>
          </div>
        </div>
        <div className="copyright">
          &copy; Midori Frauenchor all right reserved.
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.jsx